module.exports = __webpack_public_path__ + "static/media/Aveny soffa D32R zink 3493 calypso miljö 2023 1.0a4ffe7b.jpg";